import { QueryClient } from '@tanstack/react-query'
import { persistQueryClient } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

export const MAX_CACHE_AGE_PERSIST_24_HOURS = 1000 * 60 * 60 * 24

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
})

const createPersister = () => {
  try {
    if (typeof window === 'undefined') return undefined
    return createSyncStoragePersister({ storage: window.localStorage })
  } catch {
    return undefined
  }
}

const persister = createPersister()

export const initReactQueryPersist = () => {
  if (!persister) return

  try {
    const [, restorePromise] = persistQueryClient({
      queryClient,
      persister,
      maxAge: MAX_CACHE_AGE_PERSIST_24_HOURS,
      buster: 'v1',
      dehydrateOptions: {
        shouldDehydrateQuery: (query) => query.meta?.persist === true,
      }
    })
    // Storage com métodos que lançam rejeita o restore: segue sem cache persistido.
    restorePromise.catch(() => {})
  } catch (error) {
    console.error('Failed to initialize React Query persistence:', error)
  }
}

export const clearCache = () => {
  queryClient.clear();
  try {
    persister?.removeClient()
  } catch {
  }
}
